import Vue from "vue";
import Router from "vue-router";
import Scenarios from "./views/Scenarios";
import Login from "./Login";
import User from "./views/User";
import UserService from "./services/user.service";
import ScenarioUpload from "./views/ScenarioUpload";
import MyScenarios from "./views/MyScenarios";
import ScenarioEdit from "./views/ScenarioEdit";
import MediaEdit from "./views/MediaEdit";
import ScenarioView from "./views/ScenarioView";
import MediaView from "./views/MediaView";
import MyProfile from "./views/MyProfile";
import MyOrganisation from "./views/MyOrganisation";
import MyPasswordChange from "./views/MyPasswordChange";
import MyPasswordChangeUpdate from "./views/MyPasswordChangeUpdate";
import MyPasswordChangeFirstLogin from "./views/MyPasswordChangeFirstLogin";
import MyPasswordSent from "./views/MyPasswordSent";
import MyDetailsChange from "./views/MyDetailsChange";
import MyProvisioning from "./views/MyProvisioning";
import MyContracts from "./views/MyContracts";
import MySupport from "./views/MySupport";
import MyRemoteSupport from "./views/MyRemoteSupport";
import MediaItems from "./views/MediaItems";
import MediaUpload from "./views/MediaUpload";
import MyMediaItems from "./views/MyMediaItems";
import MyLicenseClaim from "./views/MyLicenseClaim";
import MyPreReleases from "./views/MyPreReleases";
import MyDownloads from "./views/MyDownloads";
import Terms from "./views/Terms";
import Privacy from "./views/Privacy";
import Vue2Crumbs from "vue-2-crumbs";
import { store } from "./store/store";
import Maintenance from "./views/Maintenance";
import { MAINTENANCE_MODE } from "./constants/maintenance";

Vue.use(Router);
Vue.use(Vue2Crumbs);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/maintenance",
      name: "maintenance",
      component: Maintenance,
      meta: { navigationAvailable: false }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: { navigationAvailable: false }
    },
    {
      path: "/logout",
      name: "logout",
      beforeEnter: (to, from, next) => {
        UserService.logout();
        return next({ path: "/login" });
      }
    },
    {
      path: "/",
      redirect: "scenarios"
    },
    {
      path: "/scenarios",
      name: "scenarios",
      meta: {
        breadcrumb: {
          label: "Scenarios"
        },
        navigationAvailable: true
      },
      component: Scenarios
    },
    {
      path: "/media",
      name: "media",
      meta: {
        breadcrumb: {
          label: "Media"
        },
        navigationAvailable: true
      },
      component: MediaItems
    },
    {
      path: "/scenario/:uuidId",
      name: "scenario-view",
      component: ScenarioView,
      meta: {
        breadcrumb: {
          label: "View Scenario",
          parent: "scenarios"
        },
        navigationAvailable: true
      }
    },
    {
      path: "/media/upload",
      name: "media-upload",
      component: MediaUpload,
      meta: {
        breadcrumb: {
          label: "Media Upload",
          parent: "my-profile"
        },
        navigationAvailable: true
      }
    },
    {
      path: "/media/:uuidId",
      name: "media-view",
      component: MediaView,
      meta: {
        breadcrumb: {
          label: "View Media",
          parent: "media"
        },
        navigationAvailable: true
      }
    },
    {
      path: "/me",
      name: "my-profile",
      meta: {
        breadcrumb: {
          label: "My Profile"
        },
        navigationAvailable: true
      },
      component: MyProfile
    },
    {
      path: "/me/profile",
      name: "my-profile-details-change",
      component: MyDetailsChange,
      meta: {
        breadcrumb: {
          label: "Update Details",
          parent: "my-profile"
        },
        navigationAvailable: true
      }
    },
    {
      path: "/me/password",
      name: "my-password",
      component: MyPasswordChange,
      meta: {
        breadcrumb: {
          label: "Change Password",
          parent: "my-profile"
        },
        navigationAvailable: true
      }
    },
    {
      path: "/me/password/firstlogin",
      name: "my-password-firstlogin",
      component: MyPasswordChangeFirstLogin,
      meta: {
        breadcrumb: {
          label: "Change Password",
          parent: "my-profile"
        },
        navigationAvailable: false
      }
    },
    {
      path: "/me/scenarios",
      name: "my-scenarios",
      meta: {
        breadcrumb: {
          label: "My Scenarios",
          parent: "my-profile"
        },
        navigationAvailable: true
      },
      component: MyScenarios
    },
    {
      path: "/scenario/:uuidId/edit",
      name: "scenario-edit",
      component: ScenarioEdit,
      meta: {
        breadcrumb: {
          label: "Edit Scenario",
          parent: "my-scenarios"
        },
        navigationAvailable: true
      }
    },
    {
      path: "/me/media",
      name: "my-media",
      meta: {
        breadcrumb: {
          label: "My Media",
          parent: "my-profile"
        },
        navigationAvailable: true
      },
      component: MyMediaItems
    },
    {
      path: "/media/:uuidId/edit",
      name: "media-edit",
      component: MediaEdit,
      meta: {
        breadcrumb: {
          label: "Edit Media",
          parent: "my-media"
        },
        navigationAvailable: true
      }
    },
    {
      path: "/scenarios/upload",
      name: "scenarios-upload",
      component: ScenarioUpload,
      meta: {
        breadcrumb: {
          label: "Scenario Upload",
          parent: "my-profile"
        },
        navigationAvailable: true
      }
    },
    {
      path: "/me/provisioning",
      name: "provisioning",
      component: MyProvisioning,
      meta: {
        breadcrumb: {
          label: "Provision Device",
          parent: "my-profile"
        },
        navigationAvailable: true
      }
    },
    {
      path: "/me/claim/:contractId",
      name: "my-claim",
      component: MyLicenseClaim,
      meta: {
        breadcrumb: {
          label: "Claim A License",
          parent: "provisioning"
        },
        navigationAvailable: true
      }
    },
    {
      path: "/me/pre-release",
      name: "my-pre-release",
      component: MyPreReleases,

      meta: {
        breadcrumb: {
          label: "View Pre-Releases",
          parent: "my-profile"
        },
        navigationAvailable: false
      }
    },
    {
      path: "/me/downloads",
      name: "my-downloads",
      component: MyDownloads,

      meta: {
        breadcrumb: {
          label: "Available Downloads",
          parent: "my-profile"
        },
        navigationAvailable: false
      }
    },
    {
      path: "/me/support",
      name: "my-support",
      component: MySupport,

      meta: {
        breadcrumb: {
          label: "Support Information",
          parent: "my-profile"
        },
        navigationAvailable: true
      }
    },
    {
      path: "/privacy",
      name: "privacy",
      component: Privacy,
      meta: {
        breadcrumb: {
          label: "Privacy Policy",
          parent: "my-profile"
        },
        navigationAvailable: true
      }
    },
    {
      path: "/terms",
      name: "terms",
      component: Terms,
      meta: {
        breadcrumb: {
          label: "Terms & Conditions",
          parent: "my-profile"
        },
        navigationAvailable: true
      }
    },
    {
      path: "/view-user/:id",
      name: "view-user",
      component: User,
      meta: {
        breadcrumb: {
          label: "View User"
        },
        navigationAvailable: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (MAINTENANCE_MODE && to.path !== "/maintenance") {
    return next({ path: "/maintenance" });
  }
  if (!MAINTENANCE_MODE && to.path === "/maintenance") {
    return next({ path: "/" });
  }
  if (to.path === "/maintenance") {
    return next();
  }

  const publicPages = ["/login"];
  const authRequired = !publicPages.includes(to.path.toLowerCase());

  if (authRequired && !store.getters.getAuthed) {
    return next({
      path: "/Login"
    });
  }

  if (to.path === "/me/password/firstlogin") {
    store.commit("setShowTutorial", false);
  }

  const firstLoginIgnore = [
    ...publicPages,
    "/logout",
    "/me/password/firstlogin"
  ];

  if (
    !firstLoginIgnore.includes(to.path.toLowerCase()) &&
    store.getters.getUser.force_password_change
  ) {
    return next({
      path: "/me/password/firstlogin"
    });
  }

  const showTutorialFromThesePages = ["/me/password/firstlogin", "/login"];

  // The user has updated their password from first login,
  // so now we can show the tutorial if they haven't hidden it permanently
  if (
    showTutorialFromThesePages.includes(from.path.toLowerCase()) &&
    !firstLoginIgnore.includes(to.path.toLowerCase()) &&
    !store.getters.getHideTutorialPermanently
  ) {
    store.commit("setShowTutorial", true);
  }

  next();
});

export default router;
